import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"

export const LabChannelStats = z.object({
    mean: z.number(),
    stddev: z.number().check(z.gte(0)),
})

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            // only supplied for interactive preview (see OperatorRecolor.createImageOpGraph); otherwise the node computes it live
            sourceStats: z.optional(
                z.object({
                    l: LabChannelStats,
                    a: LabChannelStats,
                    b: LabChannelStats,
                }),
            ),
            targetStats: z.object({
                l: LabChannelStats,
                a: LabChannelStats,
                b: LabChannelStats,
            }),
            luminance: z._default(z.number().check(z.gte(0), z.lte(1)), 1),
            colorIntensity: z._default(z.number().check(z.gte(0), z.lte(1)), 1),
            fade: z._default(z.number().check(z.gte(0), z.lte(1)), 1),
        }),
    },
}
